import type { MessageInfo } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

const SERVICE_PATH = 'rest/resource';

export async function getUnreadMessages(): Promise<MessageInfo> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/messages/unread`);
}

export async function getUnreadMessagesWithCustomerDialog(): Promise<MessageInfo> {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}/messages/unread-messages`);
}
